'use client'

import {Routes} from '@/src/config/routes'

import {CatalogSection} from '@/src/core/domain/entities/catalog'

import * as UI from './catalog.sections.styled'
import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Image} from '@/src/shared/ui/image'
import first from 'lodash/first'
import {useState} from 'react'

export const CatalogSections = ({sections, className}: {sections: CatalogSection[]; className?: string}) => {
  const [openedSectionId, setOpenedSectionId] = useState<Nullable<CatalogSection['id']>>(null)

  return (
    <UI.Wrapper className={className}>
      <CatalogSectionList>
        {sections.map(section => (
          <CatalogSectionItem
            section={section}
            key={section.id}
            openedSectionId={openedSectionId}
            onOpenSection={setOpenedSectionId}
          />
        ))}
      </CatalogSectionList>
    </UI.Wrapper>
  )
}

const CatalogSectionList = ({children}: React.PropsWithChildren) => {
  return <UI.CatalogSectionList>{children}</UI.CatalogSectionList>
}

const CatalogSectionItem = ({
  section,
  openedSectionId,
  onOpenSection,
}: {
  section: CatalogSection
  openedSectionId: Nullable<CatalogSection['id']>
  onOpenSection?: (id: CatalogSection['id']) => void
}) => {
  return (
    <UI.ItemWrapper onClick={() => onOpenSection && onOpenSection(section.id)}>
      <UI.Item>
        <UI.Image>
          <Image
            src={(section.images ?? []).length > 0 ? first(section.images) as string : noPhotoPic}
            width={200}
            height={269}
          />
        </UI.Image>
        <UI.ItemHead href={Routes.catalog.section.page(section.path)}>{section.name}</UI.ItemHead>
      </UI.Item>
      <UI.ChildrenContainer>
        <UI.Children $open={openedSectionId === section.id}>
          {section.children &&
            section.children.map(subSection => (
              <UI.ItemChild key={subSection.id}>
                <CatalogSubSectionItem section={subSection} />
              </UI.ItemChild>
            ))}
        </UI.Children>
      </UI.ChildrenContainer>
    </UI.ItemWrapper>
  )
}

const CatalogSubSectionItem = ({section}: {section: CatalogSection}) => {
  return (
    <>
      <UI.SubItemHead href={Routes.catalog.section.page(section.path)}>{section.name}</UI.SubItemHead>
      {section.children &&
        section.children.map(subSection => (
          <UI.ItemChild key={subSection.id}>
            <CatalogSubSectionItem section={subSection} />
          </UI.ItemChild>
        ))}
    </>
  )
}
